import { formatNumber } from '@/general/helpers/formatNumber';
import { FilterValues } from '@/types/CataloguePage.types';

import { RangeFilterType, UnitProcessor } from '../components/PlpFilters/PlpFilters.type';

export const processUnitDoNothing: UnitProcessor = (value: string) => value;

export const processNumberUnit = (value: string) => formatNumber(value);

export const processPriceUnit = (value: string) => {
  const parsedValue = parseInt(value, 10);
  return `${Math.floor(parsedValue / 1000)}K`;
};

export const CommonRangeFilterTypeMap = new Map<FilterValues, string>([
  [FilterValues.CashMin, RangeFilterType.price],
  [FilterValues.CashMax, RangeFilterType.price],
  [FilterValues.FinanceMin, RangeFilterType.finance],
  [FilterValues.FinanceMax, RangeFilterType.finance],
  [FilterValues.YearMin, RangeFilterType.year],
  [FilterValues.YearMax, RangeFilterType.year],
  [FilterValues.KMMin, RangeFilterType.km],
  [FilterValues.KMMax, RangeFilterType.km],
  [FilterValues.FuelConsumptionMin, RangeFilterType.fuel],
  [FilterValues.FuelConsumptionMax, RangeFilterType.fuel],
  [FilterValues.TowCapBrakedMin, RangeFilterType.towCap],
  [FilterValues.TowCapBrakedMax, RangeFilterType.towCap],
]);
